import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const navDefaultVariants = {}
const navCompoundVariants = []

const navSlotNames = [
  [
    "root",
    "nav__root"
  ],
  [
    "title",
    "nav__title"
  ],
  [
    "list",
    "nav__list"
  ],
  [
    "listItem",
    "nav__listItem"
  ],
  [
    "link",
    "nav__link"
  ],
  [
    "footer",
    "nav__footer"
  ]
]
const navSlotFns = /* @__PURE__ */ navSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, navDefaultVariants, getSlotCompoundVariant(navCompoundVariants, slotName))])

const navFn = memo((props = {}) => {
  return Object.fromEntries(navSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const navVariantKeys = []
const getVariantProps = (variants) => ({ ...navDefaultVariants, ...compact(variants) })

export const nav = /* @__PURE__ */ Object.assign(navFn, {
  __recipe__: false,
  __name__: 'nav',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: navVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, navVariantKeys)
  },
  getVariantProps
})